// class HeartBeatTimer {
//   private intervalId: NodeJS.Timeout | null = null;
//   private callback: () => Promise<void>;
//   private intervalMs: number;

//   constructor(callback: () => Promise<void>, intervalMs: number = 10000) {
//     this.callback = callback;
//     this.intervalMs = intervalMs;
//   }

//   // Start the timer
//   start() {
//     if (this.intervalId) return; // Prevent multiple intervals
//     this.callback(); // Call immediately
//     this.intervalId = setInterval(this.callback, this.intervalMs);
//   }

//   // Pause the timer
//   pause() {
//     if (this.intervalId) {
//       clearInterval(this.intervalId);
//       this.intervalId = null;
//     }
//   }

//   // Reset the timer
//   reset() {
//     this.pause();
//   }
// }

// export default HeartBeatTimer;

class HeartBeatTimer {
  private timeoutId: NodeJS.Timeout | null = null;
  private callback: () => Promise<void>;
  private intervalMs: number;
  private remainingTime: number | null = null;
  private lastStartTime: number | null = null;

  constructor(callback: () => Promise<void>, intervalMs: number = 10000) {
    this.callback = callback;
    this.intervalMs = intervalMs;
  }

  // Start the timer
  start() {
    if (this.timeoutId) return; // Prevent multiple timeouts

    if (this.remainingTime === null) {
      // First start or after a reset
      this.remainingTime = this.intervalMs;
      this.callback(); // Call immediately
    }

    this.lastStartTime = Date.now();
    this.timeoutId = setTimeout(() => this.run(), this.remainingTime);
  }

  // Internal method to handle recurring callbacks
  private run() {
    this.callback().then(() => {
      this.lastStartTime = Date.now();
      this.remainingTime = this.intervalMs;
      this.timeoutId = setTimeout(() => this.run(), this.intervalMs);
    });
  }

  // Pause the timer
  pause() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;

      if (this.lastStartTime !== null) {
        const elapsed = Date.now() - this.lastStartTime;
        this.remainingTime = Math.max(this.intervalMs - elapsed, 0);
      }
    }
  }

  // Reset the timer
  reset() {
    this.pause();
    this.remainingTime = null; // Clear the remaining time
  }
  decrement(seconds: number = 1) {
    if (this.remainingTime !== null) {
      this.remainingTime = Math.max(this.remainingTime - seconds * 1000, 0);
    }
  }
}

export default HeartBeatTimer;
